// import { data } from "isotope-layout";
import PropTypes from "prop-types";
import React from 'react';
// import {Link} from "react-router-dom";
// import FileName from '../../data/pic/filename.json';



const WorkDetailsContainer = () => {
    // const cate = data.categories.map((value, i) => {
    //     return(
    //         <span className="d-inline" key={i}>{value}{i !== data.categories.length - 1 && " , "}</span>
    //     )
    // })
    return (
        <div className="section section-padding">
            <div className="container">
                <div className="row pt--100 pb--80">

                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="work-left work-details" data-aos="fade-up">
                            <div className="portfolio-main-info">
                                <h2 className="title">Wonderful Moments </h2>
                                <div className="work-details-list mt-12">

                                    <div className="details-list">
                                        <label>Years</label>
                                        <span>2024</span>
                                    </div>
                                    <div className="details-list">
                                        <label>Date</label>
                                        <span>13th-16th, Dec</span>
                                    </div>

                                    <div className="details-list">
                                        <label>Location</label>
                                        <span> Ho Chi Minh City, Vietnam</span>
                                    </div>


                                    {/* <div className="details-list">
                                        <label>Awards</label>
                                        <span>{data.awards}</span>
                                    </div> */}

                                </div>
                                {/* <div className="work-share pt--70 pt_md--40 pt_sm--40">
                                    <h6 className="heading heading-h6">SHARE</h6>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-6 offset-lg-1 col-12">
                        <div className="work-left work-details mt-6">
                            <div className="work-main-info">
                                <div className="work-content">
                                    <h4 className="title" data-aos="fade-up">The Ninth International Conference on Data Mining and Big Data (DMBD&apos;2024)</h4>

                                    <div className="desc mt-8">
                                        <p>
                                    On Dec 13, The 9th International Conference on Data Mining and Big Data (DMBD&apos;2024) was Successfully Concluded in Ho Chi Minh City. 
                                        </p>

                                        <p>
                                    The DMBD&apos;2024 provided an excellent opportunity and/or an academic forum for academics and practitioners to present and discuss the latest scientific results and methods, innovative ideas, and advantages in theories, technologies, and applications. The technical program covered a number of aspects of data mining, big data and its related areas.

                                        </p>
                                    


                                    


                                        {/* {data.body.map((value, i) => {
                                            return(
                                                <div key={i} className="content mb-5" data-aos="fade-up" dangerouslySetInnerHTML={{__html: value}} />
                                            )
                                        })} */}
{/* DONE: fix the linkage problem  */}
                                        {/* <div className="work-btn" data-aos="fade-up">
                                            <a className="btn btn-primary btn-hover-secondary" href="www.baidu.com">Baidu</a>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
    <div className="col-lg-12 col-md-6 col-12">
        <div className="thumbnail" data-aos="fade-up">
        <a href="./images/gallery/1.jpg">

            <img className="w-100" src="./images/gallery/1.jpg" alt="Agency" /></a>
        </div>
    </div>


</div>

                {/* <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Tutorial</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The tutorial started at 8:00 am on Dec 10. The chairman of DMBD&apos;2023, Prof. Bi Ying give the speech Evolutionary Deep Learning for Image Classification: A Genetic Programming Approach </p>
                            </div>
                        </div>
                    </div>
                </div> */}

{/* 
                <div className="custom-layout-gallery mt-lg-20 mt-12">

                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_2539.jpg">

                                <img className="w-100" src="./images/gallery/IMG_2539.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_2707.jpg">

                                <img className="w-100" src="./images/gallery/IMG_2707.jpg" alt="Agency" /></a>
                            </div>
                        </div>


                    </div>
                </div> */}


                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Opening Ceremony</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The conference officially started at 9:00 am on Dec 15. The chairman of DMBD&apos;2024, Prof. Tan Ying presided over the opening ceremony of the conference and gave an opening speech. Prof. Tan Ying reported on the meeting and extended a warm welcome to everyone. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">

<div className="row">
    <div className="col-lg-6 col-md-6 col-12">
        <div className="thumbnail" data-aos="fade-up">
        <a href="./images/gallery/2.jpg">

            <img className="w-100" src="./images/gallery/2.jpg" alt="Agency" /></a>
        </div>
    </div>
    <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
        <div className="thumbnail" data-aos="fade-up">
        <a href="./images/gallery/3.jpg">

            <img className="w-100" src="./images/gallery/3.jpg" alt="Agency" /></a>
        </div>
    </div>


</div>
</div>


                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Plenary Speech</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>DMBD&apos;2024 was honored to invite Prof.Ying Tan to give a plenary speech at the conference. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">
 
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/4.jpg">

                                <img className="w-100" src="./images/gallery/4.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/5.jpg">

                                <img className="w-100" src="./images/gallery/5.jpg" alt="Agency" /></a>
                            </div>
                        </div>


                    </div>
                    {/* <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_3451.jpg">

                                <img className="w-100" src="./images/gallery/IMG_3451.jpg" alt="Agency" /></a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/IMG_3649.jpg">

                                <img className="w-100" src="./images/gallery/IMG_3649.jpg" alt="Agency" /></a>
                            </div>
                        </div>


                    </div> */}
                </div>


                {/* ---------------------------invited best student paper presentation */}

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Invited Presentation</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>We invited the author of the Best Paper and the Best Student Paper to presented their works at the conference.
</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/6.jpg">

                                <img className="w-100" src="./images/gallery/6.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/7.jpg">

                                <img className="w-100" src="./images/gallery/7.jpg" alt="Agency" />
                                </a>
                            </div>
                        </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/8.jpg">
                                <img className="w-100" src="./images/gallery/8.jpg" alt="Agency" />

                            </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/9.jpg">

                                <img className="w-100" src="./images/gallery/9.jpg" alt="Agency" />
                            </a>
                            </div>

                        </div>


                    </div>

                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/10.jpg">
                                <img className="w-100" src="./images/gallery/10.jpg" alt="Agency" />

                            </a>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                            <a href="./images/gallery/11.jpg">

                                <img className="w-100" src="./images/gallery/11.jpg" alt="Agency" />
                            </a>
                            </div>

                        </div>


                    </div>


                    </div>
                </div>

{/* -------------------------------------------------------------- */}
{/* parellel sessions */}
{/* -------------------------------------------------------------- */}
                {/* <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Parallel Sessions</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>All the authors of DMBD&apos;2024 presented their papers at the conference. There are four parallel sessions meeting rooms in total. Participants can choose topics and papers of interest, listen to their reports and communicate with the authors. </p>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* gallery */}
                {/* <div className="custom-layout-gallery mt-lg-20 mt-12">

                    <div className="row">

                        {FileName.map((data, i) => {
                            return(
                                <div className="col-lg-4 col-md-4 col-12" key={i}>
                                                <div className="thumbnail" data-aos="fade-up">
                                                    <a href={"./images/gallery/" +data.file}>
                                                    <img className="w-100" src={"./images/gallery/" +data.file} alt={data.file} />
                                                    </a>
                                                </div>
                                            </div>
                                            )
                                        })}


                    </div>
                </div> */}
{/* -------------------------------------------------------------- */}
{/* award ceremony */}
{/* -------------------------------------------------------------- */}
                            {/* <div className="row mt-lg-20 mt-12">
                                <div className="col-lg-4 col-md-12 col-12">
                                    <div className="digital-marketing" data-aos="fade-up">
                                        <h3 className="heading heading-h3">Award Ceremony
</h3>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                                    <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                                        <div className="inner">
                                            <p>On the evening of Dec 10, the conference held an award ceremony. Prof. Ying Tan announced all the awards of this year&apos;s conference and took a group photo with them. </p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* gallery */}
                            {/* <div className="custom-layout-gallery mt-lg-20 mt-12"> */}
                                    {/* big one */}
                                    {/* <div className="col-lg-12 my-6">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/plenary talk 1.jpg" alt="Agency" />
                                        </div>
                                    </div> */}
                                {/* <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/IMG_4635.jpg" alt="Agency" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/IMG_4648.jpg" alt="Agency" />
                                        </div>
                                    </div>
            
            
                                </div> */}

            


                            {/* </div> */}
            {/* -------------------------------------------------------------- */}


            </div>
        </div>
    )
}

WorkDetailsContainer.propTypes = {
    data: PropTypes.object
};

export default WorkDetailsContainer;
